import { render, staticRenderFns } from "./Geoscript.vue?vue&type=template&id=31d87dd8&scoped=true&"
import script from "./Geoscript.vue?vue&type=script&lang=js&"
export * from "./Geoscript.vue?vue&type=script&lang=js&"
import style0 from "./Geoscript.vue?vue&type=style&index=0&id=31d87dd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d87dd8",
  null
  
)

export default component.exports